import { Stack } from '@mui/material';
import noData from '../../../../assets/noData.png';
import { Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { useMediaQuery } from '@mui/material';

const CustomEmptyTable = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <tr>
      <td colSpan={8}>
        <Stack alignItems='center' mt={2}>
          <img src={noData} alt='no data available' width={isMobile ? '30%' : '15%'} />
          <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>
            No applications available!
          </Typography>
        </Stack>
      </td>
    </tr>
  );
};

export default CustomEmptyTable;
